import React from 'react';
import { useIntl } from 'react-intl';

import FormButton from '@components/form/form-button';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle
} from '@components/modal';
import { useVismaConfiguration } from '@services/visitor-management';

interface DeleteRegistrantConfirmModalProps {
  open: boolean;
  closeModal: () => void;
  deleteRegistrant: () => void;
}

function DeleteRegistrantConfirmModal({
  open,
  closeModal,
  deleteRegistrant
}: DeleteRegistrantConfirmModalProps) {
  const intl = useIntl();
  const { configuration } = useVismaConfiguration();
  const gi = configuration?.generalInformation;
  return (
    <Modal open={open} onCancel={closeModal} footer={null}>
      <ModalTitle>{intl.formatMessage({ id: 'ARE_YOU_SURE' })}</ModalTitle>
      <ModalContent>
        {intl.formatMessage({ id: 'DELETE_REGISTRANT_DESC' })}
      </ModalContent>
      <ModalFooter>
        <FormButton withLeftArrow variant="outlined" onClick={closeModal}>
          {gi?.button_quit ?? intl.formatMessage({ id: 'QUIT' })}
        </FormButton>
        <FormButton withRightArrow type="primary" onClick={deleteRegistrant}>
          {intl.formatMessage({ id: 'DELETE' })}
        </FormButton>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteRegistrantConfirmModal;
